export const NEWFCM = 'NEWFCM';
export const DELETEFCM = 'DELETEFCM';
export const UPDATEFCM = 'UPDATEFCM';
export const CONTROLFCM = 'CONTROLFCM';
export const ONECONTROLFCM = 'ONECONTROLFCM';
export const SHOW_LOADING = 'SHOW_LOADING'
export const SENDFCM = 'SENDFCM'

